const getAiTaskProjectMessage = ({aiProjectEnabled, aiTaskEnabled, type = null}) => {
    if(aiProjectEnabled && aiTaskEnabled){
        return '';
    }
    const isTaskAndProjectDisabled = !aiProjectEnabled && !aiTaskEnabled;
    const message = !type
        ? `You can enable it here but AI needs to be enabled at both a project and task level.`
        : `AI needs to be enabled at both a project and task level.`;
    return `AI is currently disabled at a ${!aiProjectEnabled ? 'project' : ''}${isTaskAndProjectDisabled ? ' and ' : ''}${!aiTaskEnabled ? 'task' : ''} level.  ${message}`;
};

export default getAiTaskProjectMessage;
